import { render } from "./ImportSourcesDialog.vue?vue&type=template&id=37cccaf4"
import script from "./js/importSourcesDialog.js?vue&type=script&lang=js&external"
export * from "./js/importSourcesDialog.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__